import { browser } from '$app/environment';
// import { afterNavigate, beforeNavigate } from '$app/navigation';
import { cfgPosthog } from '@infinitro/config';
import posthog from 'posthog-js';
const POSTHOG_API_KEY = cfgPosthog();
export const initAnalytics = async () => {
    try {
        if (browser && POSTHOG_API_KEY) {
            posthog.init(POSTHOG_API_KEY, {
                api_host: 'https://posthog.flush.com',
                ui_host: 'https://app.posthog.com',
                capture_pageview: false,
                capture_pageleave: false
            });
            // beforeNavigate(() => {
            // 	console.log(`beforeNavigate: ${window.location.pathname}`);
            // 	posthog.capture('$pageleave');
            // });
            // afterNavigate(() => {
            // 	console.log(`afterNavigate: ${window.location.pathname}`);
            // 	posthog.capture('$pageview');
            // });
        }
    }
    catch (e) {
        console.log(`posthog initAnalytics failed: ${e}`);
    }
};
export { posthog };
